import React from 'react';
import { XCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { formatCountdown } from '../../utils/formatting';

type CooldownAlertProps = {
  id: string;
  secondsLeft: number;
};

/** A locked verification method: how long until it can be tried again. Renders nothing once the lock is over. */
export default function CooldownAlert({ id, secondsLeft }: CooldownAlertProps) {
  const { t } = useTranslation('wizard');
  if (secondsLeft <= 0) return null;

  return (
    <div id={id} role="alert" className="bg-red-50 text-red-600 p-4 rounded-lg flex items-center gap-2">
      <XCircle className="w-5 h-5 flex-shrink-0" />
      <span className="text-sm">
        {t('verificationCooldown.message', { count: Math.ceil(secondsLeft / 60) })}{' '}
        {t('contactInfo.retryIn', { time: formatCountdown(secondsLeft) })}
      </span>
    </div>
  );
}
